import React from 'react';
import { motion } from 'framer-motion';
import { UserIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function StoryCredibility() {
  const {
    t
  } = useLanguage();
  return <section id="nosotros" className="py-12 bg-brand-bg-dark border-y border-brand-gold/10" data-id="element-320">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-321">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-322">
          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-323">
            <UserIcon className="w-10 h-10 text-brand-gold" data-id="element-324" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-325">
              {t('story.title')}
            </h2>
          </div>

          <div className="prose prose-lg prose-invert mx-auto" data-id="element-326">
            <p className="text-xl text-gray-300 leading-relaxed mb-8" data-id="element-327">
              {t('story.p1')}
            </p>

            <p className="text-xl text-gray-300 leading-relaxed mb-10" data-id="element-328">
              {t('story.p2')}
            </p>

            <blockquote className="text-3xl sm:text-4xl font-heading font-bold text-brand-gold text-center my-8 py-6 border-y border-brand-gold/20 bg-brand-gold/5" data-id="element-329">
              {t('story.quote')}
            </blockquote>

            <p className="text-xl text-gray-300 leading-relaxed mb-8" data-id="element-330">
              {t('story.p3')}
              <strong className="text-white font-heading tracking-wide" data-id="element-331">
                {t('story.p3_strong')}
              </strong>{' '}
              {t('story.p3_end')}
            </p>

            <p className="text-xl text-gray-300 leading-relaxed" data-id="element-332">
              {t('story.p4')}
              <strong className="text-brand-gold" data-id="element-333">
                {t('story.p4_strong')}
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}